import { render } from "./leadAdd.vue?vue&type=template&id=722f0be6&scoped=true"
import script from "./leadAdd.vue?vue&type=script&lang=js"
export * from "./leadAdd.vue?vue&type=script&lang=js"

import "./leadAdd.vue?vue&type=style&index=0&id=722f0be6&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722f0be6"]])

export default __exports__